import React from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
const BOOKS_IMG = 'https://cdn.magicpatterns.com/uploads/bhFSrSEpMQzWKRAtD8S14k/Fotografa_de_producto_de_ultra_Nano_Banana_2_93471.jpg';
const items = [{
  name: 'Tomo 1 — El Interruptor',
  oldPrice: '$5.990',
  status: 'INCLUIDO'
}, {
  name: 'Tomo 2 — Ingeniería de Guion',
  oldPrice: '$5.990',
  status: 'INCLUIDO'
}, {
  name: 'Tomo 3 — El Vacío Cuántico',
  oldPrice: '$5.990',
  status: 'INCLUIDO'
}, {
  name: 'Tomo 4 — El Cuerpo Magnético',
  oldPrice: '$5.990',
  status: 'INCLUIDO'
}, {
  name: 'Tomo 5 — El Guardián del Sueño',
  oldPrice: '$5.990',
  status: 'INCLUIDO'
}, {
  name: 'Bono 1 — El Radar de Sincronías',
  oldPrice: '$3.990',
  status: 'GRATIS'
}, {
  name: 'Bono 2 — Guiones de Auto-Hipnosis',
  oldPrice: '$3.990',
  status: 'GRATIS'
}, {
  name: 'Bono 3 — El Plan de 21 Días',
  oldPrice: '$3.990',
  status: 'GRATIS'
}];
export function FinalCTASection() {
  return <SectionWrapper bgColor="bg-brand-dark" className="relative" data-id="element-55">
      {/* Books background behind price reveal */}
      <div className="absolute inset-0 bg-center bg-no-repeat bg-cover opacity-[0.1] pointer-events-none" style={{
      backgroundImage: `url(${BOOKS_IMG})`,
      backgroundPosition: 'center 55%',
      maskImage: 'radial-gradient(ellipse at center bottom, black 20%, transparent 70%)',
      WebkitMaskImage: 'radial-gradient(ellipse at center bottom, black 20%, transparent 70%)'
    }} data-id="element-56" />

      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_center,rgba(212,175,55,0.05),transparent_60%)] pointer-events-none" data-id="element-57" />

      <div className="relative" data-id="element-58">
        <h2 className="font-heading text-2xl md:text-3xl text-brand-ivory text-center font-semibold" data-id="element-59">
          Lo que recibís hoy mismo:
        </h2>

        <div className="mt-10 max-w-xl mx-auto space-y-3" data-id="element-60">
          {items.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-61">
              <span className="text-brand-gold shrink-0 mt-0.5" data-id="element-62">✦</span>
              <div className="flex flex-wrap items-baseline gap-x-2" data-id="element-63">
                <span className="text-brand-ivory font-body text-base font-medium" data-id="element-64">
                  {item.name}
                </span>
                <span className="text-brand-muted-dark line-through text-sm" data-id="element-65">
                  {item.oldPrice}
                </span>
                <span className="text-brand-gold font-body font-bold text-sm" data-id="element-66">
                  {item.status}
                </span>
              </div>
            </div>)}

          <div className="flex items-start gap-3 pt-2" data-id="element-67">
            <span className="text-brand-gold shrink-0 mt-0.5" data-id="element-68">✦</span>
            <span className="text-brand-ivory font-body text-base font-medium" data-id="element-69">
              Garantía 7 días{' '}
              <span className="text-brand-gold font-bold text-sm ml-2" data-id="element-70">
                INCLUIDA
              </span>
            </span>
          </div>

          <div className="flex items-start gap-3" data-id="element-71">
            <span className="text-brand-gold shrink-0 mt-0.5" data-id="element-72">✦</span>
            <span className="text-brand-ivory font-body text-base font-medium" data-id="element-73">
              Acceso inmediato{' '}
              <span className="text-brand-gold font-bold text-sm ml-2" data-id="element-74">
                INCLUIDO
              </span>
            </span>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-75">
          <p className="text-brand-muted font-heading text-xl" data-id="element-76">
            Valor total: <span className="line-through" data-id="element-77">$41.920</span>
          </p>

          <p className="font-heading text-5xl md:text-7xl text-brand-gold font-bold mt-6" style={{
          textShadow: '0 0 50px rgba(212,175,55,0.35)'
        }} data-id="element-78">
            HOY SOLO: $19.990
          </p>
        </div>

        <div className="mt-12" data-id="element-79">
          <CTAButton text="→ SÍ, QUIERO TRANSFORMAR MI VIDA POR $19.990" subtext="Clic aquí para acceso inmediato" size="large" data-id="element-80" />
        </div>
      </div>
    </SectionWrapper>;
}